import { getAmplitudeInstance } from '../amplitudeHelpers';
import SignUpScreenContinueButtonType from '../enums/SignUpScreenContinueButtonType';

type logSignUpScreenContinueButtonTappedParams = {
  signup_screen_continue_button_type?: SignUpScreenContinueButtonType;
};

/**
 * The user taps one of the 'Continue' buttons to sign in (i.e. 'Continue with Google'), or taps to create a free account.
 * @param params - Attributes to log with the amplitude event
 * @param params.signup_screen_continue_button_type - The type of sign in the user taps from the Sign Up Screen.
 */
const logSignUpScreenContinueButtonTapped = (
  { signup_screen_continue_button_type }: logSignUpScreenContinueButtonTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'sign up screen continue tapped',
    { 'sign up screen continue button type': signup_screen_continue_button_type },
    callback
  );
};

export default logSignUpScreenContinueButtonTapped;
